import { CountResponse } from '../../../../../../types/api/endpoints/stats/stats.types';
import { STATS_ENDPOINTS } from '../../../../../../utils/api/endpoints/statsEndpoints';

export const DASHBOARD_ENT_LAST_MONTHS_QUERY_KEY = 'DASHBOARD_ENT_LAST_MONTHS';

const PREFIX = '[dashboardENTLastMonthsQuery]';

export const queryDashboardENTLastMonths = async () => {
  console.log(PREFIX, `Fetching dashboard ENT last months...`);
  const response = await STATS_ENDPOINTS.dashboardENTLastMonths();

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received dashboard ENT last months.`);
  return json as CountResponse[];
};
